<nav
	id="sidebar"
	class="sidebar"
	[ngClass]="{ toggled: this.toggled$ | async }"
	*ngIf="config"
>
	<!-- Logo -->
	<div class="sidebar-brand bg-dark d-flex justify-content-center align-items-center">
		<a
			class="sidebar-brand-link"
			routerLink="/"
		>
			<ng-container
				*ngIf="config.appInfo.logoWideOnLight && config.appInfo.logoWideOnDark; else generatedWordmark"
			>
				<img
					class="sidebar-brand-wide-logo sidebar-brand-wide-logo--light"
					[src]="config.appInfo.logoWideOnLight"
					[alt]="config.appInfo.label"
				/>
				<img
					class="sidebar-brand-wide-logo sidebar-brand-wide-logo--dark"
					[src]="config.appInfo.logoWideOnDark"
					[alt]="config.appInfo.label"
				/>
			</ng-container>
			<ng-template #generatedWordmark>
				<img
					class="sidebar-brand-logo"
					[src]="config.appInfo.logoSmall"
					alt=""
					aria-hidden="true"
				/>
				<span class="sidebar-brand-wordmark">
					<span>Flying</span>
					<strong>{{ config.appInfo.label.replace('Flying ', '') }}</strong>
				</span>
			</ng-template>
		</a>
	</div>

	<!-- Sidebar content -->
	<div class="sidebar-content">
		<!-- User details -->
		<div class="sidebar-user">
			<ng-content></ng-content>
		</div>

		<!-- Sidebar navigational panel -->
		<ul class="sidebar-nav mb-3">
			<ng-container *ngFor="let list of config.pageLists">
				<!-- List header -->
				<li class="sidebar-header">{{ list.label }}</li>

				<!-- List links -->
				<li
					class="sidebar-item"
					*ngFor="let menu of list.menus"
					[id]="menu.id"
				>
					<!-- Links disabled if no associated subscription modules found -->
					<button
						*ngIf="menu.subMenus"
						type="button"
						data-bs-toggle="collapse"
						class="sidebar-link sidebar-section-label"
						[class.collapsed]="menu.isCollapsed"
						(click)="toggleMenu(menu)"
						[attr.aria-expanded]="!menu.isCollapsed"
						[attr.aria-controls]="'sidebar-menu-' + menu.id"
					>
						<!-- Page link icon and name -->
						<ng-fa-icon
							[icon]="menu.icon.name"
							[iconStyle]="menu.icon.style"
							class="me-2 text-dark"
						></ng-fa-icon>
						<span class="align-middle">{{ menu.label }}</span>
					</button>

					<!-- Children links -->
					<ul
						*ngIf="menu.subMenus"
						class="sidebar-dropdown list-unstyled collapse"
						[id]="'sidebar-menu-' + menu.id"
						[ngbCollapse]="menu.isCollapsed"
					>
						<ng-container *ngFor="let subMenu of menu.subMenus">
							<li
								class="sidebar-item my-1"
								[id]="subMenu.id"
								*ngIf="!subMenu.isHidden"
							>
								<!-- Child link name -->
								<a
									class="sidebar-link"
									*ngIf="!subMenu.isDisabled"
									[routerLink]="subMenu.routePath"
									[queryParams]="subMenu.queryParams"
									routerLinkActive="active"
									[routerLinkActiveOptions]="{ exact: subMenu.routePath === '/' }"
									[class.active]="subMenu.isSelected"
								>
									<!-- Submenu icon -->
									<ng-fa-icon
										[icon]="subMenu.icon!.name"
										[iconStyle]="subMenu.icon!.style"
										class="me-2 text-dark"
									></ng-fa-icon>

									<!-- Menu option label -->
									{{ subMenu.label }}
									<span
										class="sidebar-badge badge rounded-pill bg-primary"
										*ngIf="subMenu.info"
									>
										{{ subMenu.info }}
									</span>
								</a>

								<!-- Child link info -->
								<a
									*ngIf="subMenu.isDisabled"
									class="sidebar-link disabled d-flex justify-content-between disable-page"
									(click)="disableLinkClicked.emit(subMenu.label)"
								>
									<div>
										<!-- Submenu icon -->
										<ng-fa-icon
											[icon]="subMenu.icon!.name"
											[iconStyle]="subMenu.icon!.style"
											class="me-2 text-dark"
										></ng-fa-icon>

										<!-- Menu option label -->
										<span class="align-middle">{{ subMenu.label }}</span>
									</div>
									<div>
										<span class="align-middle text-end">
											<ng-fa-icon
												class="d-inline-flex sidebar-info"
												icon="circle-info"
											></ng-fa-icon>
										</span>
									</div>
								</a>
							</li>
						</ng-container>
					</ul>

					<!-- Link name and info -->
					<a
						*ngIf="!menu.subMenus"
						class="sidebar-link"
					>
						<!-- Submenu icon -->
						<ng-fa-icon
							[icon]="menu.icon.name"
							[iconStyle]="menu.icon.style"
							class="me-2 text-dark"
						></ng-fa-icon>

						<!-- Menu option label -->
						<span class="align-middle">{{ menu.label }}</span>
					</a>
				</li>
			</ng-container>
		</ul>
	</div>
</nav>
